module.exports = __webpack_public_path__ + "img/US_ResourceFood_ua.586c4d49.webp";